import { OptionalNullableDisplayNameSchema } from '@sg/shared/src/valibot/schema/DisplayName.type'
import { literal, nullable, object, optional, type InferOutput } from 'valibot'
import { Nullable } from '../../../../../../typescript'
import { Engine } from '../../../../engine/Engine.type'
import findPlayerByProfileId from '../../../../player/findPlayerByProfileId'
import { Player } from '../../../../player/Player.type'
import { PlayerIdSchema, type PlayerId } from '../../../../player/PlayerId'
import { PlayerKind } from '../../../../player/PlayerKind.enum'
import resetPlayerSlotToOpen from '../../../../player/resetPlayerSlotToOpen'
import { ProfileIdSchema } from '../../../../ProfileId.type'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const ClaimPlayerSlotActionSchema = object({
  type: literal(ActionType.Lobby.ClaimPlayerSlot),
  // if profile_id is null, then it's a local player
  profile: optional(nullable(object({
    id: ProfileIdSchema,
    dname: OptionalNullableDisplayNameSchema,
  }))),
  player_id: PlayerIdSchema,
})

export type ClaimPlayerSlotAction = InferOutput<typeof ClaimPlayerSlotActionSchema>

export function createClaimPlayerSlotAction(
  profile: ClaimPlayerSlotAction['profile'],
  player_id: PlayerId
): ClaimPlayerSlotAction {
  return {
    type: ActionType.Lobby.ClaimPlayerSlot,
    profile,
    player_id,
  }
}

export async function handleClaimPlayerSlotAction(
  engine: Engine,
  action: ClaimPlayerSlotAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  // console.log('handleClaimPlayerSlotAction')
  const { profile, player_id } = action
  const profile_id = profile?.id
  const profile_dname = profile?.dname
  const is_local = !profile_id || !engine.state.online

  const prevPlayerId: Nullable<PlayerId> = findPlayerByProfileId(engine.state, profile_id)?.id

  engine.state.players.forEach((player: Player) => {
    if (player.id === player_id) {
      // update the selected player
      resetPlayerSlotToOpen(player)
      player.kind = PlayerKind.Human
      player.is_local = is_local
      player.profile_id = profile_id
      player.dname = profile_dname
    } else if ((profile_id && player.profile_id === profile_id) || prevPlayerId === player.id) {
      // if the player was in a previous slot,
      // convert it to an open slot
      // update the selected player
      resetPlayerSlotToOpen(player)
    }
    return player
  })
}
